import {Component, Input} from '@angular/core';

@Component({
  selector: 'kan-expansion-panel',
  templateUrl: './component.html',
  styleUrls: ['./component.scss']
})
export class kanExpansionPanel {
  @Input() public title: string;
  @Input() public open: string;
  public show: boolean = false;

  constructor() {
  }

  ngOnInit(): void {
    this.show = !!this.open;
  }

  public toggle() {
    this.show = !this.show;
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/components/expansion-panel/component.ts